import { useContext } from "react";
import { AuthContext } from "./context.js";
export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) {
        throw new Error("useAuth must be used inside <AuthProvider>.");
    }
    return ctx;
}
export function useIsSignedIn() {
    return useAuth().state.status === "signedIn";
}
export function useBearerToken() {
    const { state } = useAuth();
    return state.status === "signedIn" ? (state.user.access_token ?? null) : null;
}
//# sourceMappingURL=hooks.js.map